import { COLORS, TYPE, SPACE } from '../tokens'
import SectionLabel from '../SectionLabel'

// Section 3: three-column adequacy grid (Limits vs Revenue / BIA / Threat Profile).
// Reads from review.findings.adequacy if the Specialist produced it. When
// absent, renders "Not assessed" columns so the section still holds shape.
function AdequacyColumn({ heading, verdict, rationale }) {
  const isConcerning = verdict === 'borderline' || verdict === 'inadequate'
  const verdictLabel = verdict ? verdict.toUpperCase() : 'NOT ASSESSED'
  return (
    <div style={{
      background: COLORS.panelBg,
      border: `1px solid ${COLORS.hairline}`,
      borderLeft: isConcerning ? `2px solid ${COLORS.amber}` : `1px solid ${COLORS.hairline}`,
      padding: '20px 24px'
    }}>
      <SectionLabel variant="severity">{heading}</SectionLabel>
      <p style={{ ...TYPE.sectionHead, color: COLORS.bodyText, margin: '12px 0 8px' }}>{verdictLabel}</p>
      <p style={{ ...TYPE.supporting, color: COLORS.mutedText, margin: 0 }}>
        {rationale || 'The Specialist did not evaluate this dimension.'}
      </p>
    </div>
  )
}

export default function CoverageAdequacy({ review }) {
  const adequacy = review?.findings?.adequacy || {}
  return (
    <section style={{ maxWidth: SPACE.sectionMaxWidth, margin: '0 auto' }}>
      <SectionLabel>Coverage adequacy</SectionLabel>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
        <AdequacyColumn heading="Limits vs Revenue" verdict={adequacy.revenue?.verdict} rationale={adequacy.revenue?.rationale} />
        <AdequacyColumn heading="Limits vs BIA" verdict={adequacy.bia?.verdict} rationale={adequacy.bia?.rationale} />
        <AdequacyColumn heading="Limits vs Threat Profile" verdict={adequacy.threat?.verdict} rationale={adequacy.threat?.rationale} />
      </div>
    </section>
  )
}
